import { ColumnMain } from "#/models/column-main";
import { Column } from "#/models/column";
import { Trans } from "@lingui/macro";
import { Tag } from "antd";
import React from "react";

const ItemModel = (): ColumnMain => {

    const columns: Array<Column> = new Array();

    columns.push({ key: 'itemNo', width: 150, filter: true, sorter: true, title: <Trans>MSC Part Number</Trans> });
    columns.push({ key: 'supplierItemNo', width: 150, filter: true, sorter: true, title: <Trans>Supplier Item No</Trans> });
    columns.push({ key: 'supplier.code', dataIndex: ['supplier', 'code'], width: 150, filter: true, sorter: true, title: <Trans>Supplier Code</Trans> });
    columns.push({ key: 'name', width: 150, filter: true, sorter: true, title: <Trans>Name</Trans> });
    columns.push({ key: 'tarricCode', width: 150, filter: true, sorter: true, title: <Trans>Tarric Code / CN Code</Trans> });
    columns.push({ key: 'tradeName', width: 200, filter: true, sorter: true, title: <Trans>Trade Name</Trans> });
    columns.push({ key: 'relevantProducts', width: 200, filter: true, sorter: true, title: <Trans>Relevant Commodity</Trans> });
    columns.push({ key: 'scientificName', width: 200, filter: true, sorter: true, title: <Trans>Scientific Name</Trans> });
    columns.push({ key: 'weight', width: 150, filter: true, sorter: true, title: <Trans>Part Weight (kg)</Trans> });
    columns.push({ key: 'productionStartDate', width: 180, dateTimeFilter: true, sorter: true, title: <Trans>Production Start Date</Trans> });
    columns.push({ key: 'productionEndDate', width: 180, dateTimeFilter: true, sorter: true, title: <Trans>Production End Date</Trans> });
    columns.push({ key: 'isSparePart', width: 130, checkboxFilter: true, sorter: true, title: <Trans>Is Spare Part</Trans> });


    columns.push({ key: 'updatedDate', width: 150, dateTimeFilter: true, sorter: true, title: <Trans>Updated Date</Trans> });
    columns.push({ key: 'updatedBy', width: 200, filter: true, sorter: true, title: <Trans>Updated By</Trans> });
    columns.push({ key: 'createdDate', width: 150, dateTimeFilter: true, sorter: true, title: <Trans>Created Date</Trans>, direction: "desc" });
    columns.push({ key: 'createdBy', width: 200, filter: true, sorter: true, title: <Trans>Created By</Trans> });

    return {
        columns: columns,
        url: "/resource/items"
    };
}
export default ItemModel();
